import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {Button, MenuItem, Select, TextField} from "@material-ui/core";
import MultiSelect from "react-multi-select-component/dist";
import {Option} from "react-multi-select-component/dist/lib/interfaces";
import {ServerApi} from "../ServerApi";
import {SearchLocationType, SearchPositionType, SearchQuery, Word} from "../models/models";
import 'react-virtualized/styles.css';
import "./WordSearchComponent.scss";
import {Actions} from "../store/Actions";
import {useDispatch, useSelector} from "react-redux";
import {StoreState} from "../store/StoreState";
import {useLocalStorage} from "@rehooks/local-storage";

const queryString = require('query-string');


// @ts-ignore
function arraysEqual(_arr1, _arr2) {
	if (!Array.isArray(_arr1) || !Array.isArray(_arr2) || _arr1.length !== _arr2.length)
		return false;

	const arr1 = _arr1.concat().sort();
	const arr2 = _arr2.concat().sort();

	for (let i = 0; i < arr1.length; i++) {

		if (arr1[i] !== arr2[i])
			return false;

	}

	return true;
}


export const WordSearchComponent: React.FC<any> = () => {
	const dispatch = useDispatch();
	const history = useHistory();

	const [allDictionaryGroups, setAllDictionaryGroups] = useState<Option[]>([]);
	const [searchKeyword, setSearchKeyword] = useState("");
	const [searchLocationType, setSearchLocationType] = useState(SearchLocationType.Term);
	const [searchPositionType, setSearchPositionType] = useState(SearchPositionType.StartsWith);
	const selectedDictionaryGroups = useSelector((state: StoreState) => state.selectedSearchDictionaryGroups);
	const [dictionaryGroupsFromLocalStorage, setSelectedDictionaryGroupsFromLocalStorage, deleteDictionaryGroupsFromLocalStorage] = useLocalStorage<number[]>('DictionaryGroupsFromLocalStorage', []);


	useEffect(() => {
		ServerApi
			.getDictionaryGroups()
			.then(dgs => {
				const allDictionaryGroups = dgs.map(dg => ({value: dg.id, label: dg.name} as Option));

				setAllDictionaryGroups(allDictionaryGroups);

				const selectedDgsExistingInLocalStorage = allDictionaryGroups.filter(dg => dictionaryGroupsFromLocalStorage.includes(dg.value));

				if (selectedDictionaryGroups.length === 0 || !arraysEqual(selectedDictionaryGroups.map(x => x.value), selectedDgsExistingInLocalStorage.map(x => x.value)))
					dispatch(Actions.setSelectedSearchDictionaryGroups(selectedDgsExistingInLocalStorage));
			});
	}, []);


	useEffect(() => {
		setSelectedDictionaryGroupsFromLocalStorage(selectedDictionaryGroups.map(dg => dg.value));
	}, [selectedDictionaryGroups]);


	useEffect(() => {
		if (searchLocationType !== SearchLocationType.Term) {
			setSearchPositionType(SearchPositionType.Contains);
		}
	}, [searchLocationType]);


	const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		const searchQuery = {
			dictionaryGroupIds: selectedDictionaryGroups.map(dg => dg.value),
			searchKeyword,
			searchLocationType,
			searchPositionType
		} as SearchQuery;

		const searchQueryString = queryString.stringify(searchQuery, {arrayFormat: 'bracket'});

		history.push(`/Search?${searchQueryString}`);
	};


	return (
		<div className="grid-container2">

			<div className="search-box">
				<form onSubmit={handleSearch}>

					<MultiSelect
						options={allDictionaryGroups}
						value={selectedDictionaryGroups}
						onChange={(options: Option[]) => dispatch(Actions.setSelectedSearchDictionaryGroups(options))}
						disableSearch={true}
						labelledBy={"사전 그룹 선택"}
						overrideStrings={
							{
								"selectSomeItems": "사전 선택...",
								"allItemsAreSelected": "전체 사전",
								"selectAll": "전체 선택",
								"search": "검색"
							}
						}
					/>

					<br/>

					<div className="flex-container">
						<TextField value={searchKeyword}
						           onChange={(e) => setSearchKeyword(e.target.value)}
						           label="검색어"
						           size="small"
						           className="item1"/>

						<Select value={searchLocationType}
						        onChange={(e) => setSearchLocationType(e.target.value as SearchLocationType)}
						        className="item2">
							<MenuItem value={SearchLocationType.Term}>제목</MenuItem>
							<MenuItem value={SearchLocationType.Description}>내용</MenuItem>
							<MenuItem value={SearchLocationType.Both}>제목+내용</MenuItem>
						</Select>

						<Select value={searchPositionType}
						        onChange={(e) => setSearchPositionType(e.target.value as SearchPositionType)}
						        className="item2">
							{searchLocationType === SearchLocationType.Term && <MenuItem value={SearchPositionType.StartsWith}>시작함</MenuItem>}
							<MenuItem value={SearchPositionType.Contains}>포함함</MenuItem>
						</Select>

						<Button className="item3" type="submit" variant="contained" color="primary">검색</Button>
					</div>
				</form>
			</div>

		</div>
	)
};